<template>
  <div
    class="i-base-header"
    :class="{ v2: $props.version === 2, 'print-page-break': $props.printBreakBefore }"
  >
    <h2
      v-if="props.highlightText"
      class="text highlight"
      :style="highLightedTextStyle"
    >
      {{ props.highlightText }}
      <h3
        v-if="props.text && props.version === 2"
        class="sub"
        :style="textStyle"
      >
        {{ props.text }}
      </h3>
    </h2>
    <h3
      v-if="props.text && props.version !== 2"
      class="text"
      :style="textStyle"
    >
      {{ props.text }}
    </h3>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { pickleBluewood900 } from "@/styles/colors"

const props = defineProps({
  version: {
    type: Number,
    default: 1
  },
  align: {
    type: String,
    default: "left"
  },
  fontSizeHighlightedText: {
    type: String,
    default: "36px"
  },
  fontSizeText: {
    type: String,
    default: "20px"
  },
  fontWeightText: {
    type: String,
    default: "700"
  },
  colorText: {
    type: String,
    default: pickleBluewood900
  },
  highlightText: {
    type: String,
    default: null
  },
  lineHeight: {
    type: String,
    default: null
  },
  text: {
    type: String,
    default: ""
  },
  printBreakBefore: {
    type: Boolean,
    default: false
  },
  bottomMargin: {
    type: String,
    default: "40px"
  }
})

const textStyle = computed((): Record<string, string> => {
  return {
    textAlign: props.align,
    fontSize: props.fontSizeText,
    lineHeight: props.lineHeight,
    fontWeight: props.fontWeightText,
    color: props.colorText
  }
})

const highLightedTextStyle = computed((): Record<string, string> => {
  return {
    textAlign: props.align,
    fontSize: props.fontSizeHighlightedText,
    lineHeight: props.lineHeight,
    "--bt-margin": props.bottomMargin
  }
})
</script>

<style scoped lang="scss">
.i-base-header {
  @include flex(column, center, center);

  margin: 0;
  width: 100%;

  &.v2 {
    .text.highlight {
      color: $azure-radiance500;
      text-transform: uppercase;
      border-bottom: 1px solid $zumthor100;
      padding-bottom: 6px;
      margin-bottom: 30px;

      @media screen and (min-width: $breakpoint-md) {
        margin-bottom: var(--bt-margin);
      }

      .sub {
        @include text-sm;

        width: 100%;
        margin: 0;
        text-transform: none;
      }
    }
  }

  .text {
    width: 100%;
    margin: 0;
    font-weight: 700;
    color: $pickle-bluewood900;

    &.highlight {
      @include display-sm;

      font-weight: 600;
      margin-bottom: 6px;
    }
  }
}

@media print {
  .i-base-header {
    &.print-page-break {
      margin-top: 5px;
      page-break-before: always;
      -webkit-page-break-before: always;
    }
  }
}
</style>
